import React, { FC, useMemo } from 'react';
import { capitalize } from '@repo-level/core-front';

import { ScError, ScInputStructure } from './styled';
import { ScAnimatedPlaceholder } from '../primitives/styled';

export interface InputStructureProps {
  error?: React.ReactNode;
  hideErrorMessage?: boolean;
  hideErrorStyles?: boolean;

  whiteWhenFilled?: boolean;
  grayLight?: boolean;

  disabled?: boolean;
  whiteTextDisabled?: boolean;
  isInputFocused?: boolean;
  successBorder?: boolean;

  animatedPlaceholder?: string;
  addons?: JSX.Element;
  hint?: JSX.Element | null;

  height?: number;
  noBorder?: boolean;
}

export const InputStructure: FC<InputStructureProps> = ({
  error,
  hideErrorMessage = false,
  hideErrorStyles = false,
  children,
  addons,
  animatedPlaceholder,
  hint,
  noBorder,
  successBorder,
  whiteTextDisabled,
  ...props
}) => {
  const isError = useMemo(() => {
    return !hideErrorMessage && error != null && error !== '';
  }, [error, hideErrorMessage]);

  return (
    <ScInputStructure
      {...props}
      error={!!error}
      withHint={!!hint}
      noBorder={noBorder}
      successBorder={successBorder}
      whiteTextDisabled={whiteTextDisabled}
    >
      {props.isInputFocused && hint}

      <div className="input-container">
        {!noBorder && <div className="border" />}

        {children}

        {animatedPlaceholder && (
          <ScAnimatedPlaceholder>
            {capitalize(animatedPlaceholder)}
          </ScAnimatedPlaceholder>
        )}

        {addons && <div className="addons">{addons}</div>}
      </div>

      {isError && <ScError hideErrorStyles={hideErrorStyles}>{error}</ScError>}
    </ScInputStructure>
  );
};
